//script 01
elasticApm.init({
    serviceName: 'processevo-platformata-website-js',
    serverUrl: 'https://' + window.location.hostname + ':20200', //TODO: refactor - this should be calculated somewhere else.
    active: false
})

// start ProcessEvo on document ready
$(function () {
    ProcessEvoApp.init();
});

//script 02
		
window.onscroll = function() {scrollFunction()};
//TODO: refactor
function scrollFunction() {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
        var headerHeigh = $('#header').outerHeight();
        var bredcrumbsHeigh = $('[class*="breadcrumbs"]').outerHeight();

        //If bredcrumbs dosent exsist (i.e. undefined), set it height size to 0
        if (typeof(bredcrumbsHeigh) === 'undefined') {
            bredcrumbsHeigh = 0;
        }
        //Gets total height and convert it to "em" units (1em = 16px)
        var mainOfset = ((headerHeigh + bredcrumbsHeigh) / 16) +"em";

        document.getElementById("header").classList.add("sticky");
        $('[class*="breadcrumbs"]').addClass("sticky-breadcrumb");
        $("nav.sticky-breadcrumb").css({"top": (headerHeigh - 0) / 16 +"em"});
        $("#main-container").css({"padding-top": mainOfset});
        $("#overlay-panel-search, #overlay-panel-cart").css({"top": (headerHeigh - 48) / 16 +"em"});

        if (window.matchMedia('(min-width: 1024px)').matches) {
            $("#prd-main-image, #scrollViewVertical, .basket__details").css({"position":"sticky","top": ( ( (headerHeigh + bredcrumbsHeigh) - 24) / 16) +"em"});
        } else {
            $("#prd-main-image, #scrollViewVertical, .basket__details").css({"position":"","top": ""});
        }

        var imgHeigh = $('#sales .prd-image, #promotions .prd-image, #related-products .prd-image').outerHeight();
        var sizeNameHeigh = $('#sales .prd-size-name, #promotions .prd-size-name, #related-products .prd-size-name').outerHeight();
        var priceHeigh = $('#sales .prd-price, #promotions .prd-price, #related-products .prd-price').outerHeight()+20;
        
        if ( typeof(sizeNameHeigh) === 'undefined') {
            sizeNameHeigh = 0;
        }

        var nameHeigh = 0;
        $('#sales .prd-name, #promotions .prd-name, #related-products .prd-name').each(function(){
            if ($(this).outerHeight() > nameHeigh) {
                nameHeigh = $(this).outerHeight();
            }
        });

        var scrollerHeigh = imgHeigh + nameHeigh + sizeNameHeigh + priceHeigh;
        $("ul.k-scrollview-wrap, li.k-scrollview-page, .k-widget.k-scrollview").css({"height": scrollerHeigh});

    } else {
        document.getElementById("header").classList.remove("sticky");
        $("nav.sticky-breadcrumb").css({"top":""}); 
        $('[class*="breadcrumbs"]').removeClass("sticky-breadcrumb");
        $("#main-container").css({"padding-top":""});
        $("#overlay-panel-search, #overlay-panel-cart").css({"top":""});

        if (window.matchMedia('(min-width: 1024px)').matches) {
            $("#prd-main-image, #scrollViewVertical, .basket__details").css({"position":"","top": ""});
            
        } else {
            $("#prd-main-image, #scrollViewVertical, .basket__details").css({"position":"sticky","top": ( ( (headerHeigh + bredcrumbsHeigh) - 24) / 16) +"em"});
        }
    }

}

window.createCampaign = function () {
    ProcessEvoApp.runQuery('get-user-profile', {}).then(user => {
        if (!user || !user.id ) {
            ProcessEvoApp.loadWorkspace('ecommerce-page-how-to-create-campaign')
        } else {
            //ProcessEvoApp.showLoader()
            
            ProcessEvoApp.runQuery('query-webshop-profile-view', { }).then(profile => {

            let legalTypeCode = profile.legalTypeCode;

            if (profile.campaignCount >= 3) {
                ProcessEvoApp.showNotification("Вече имате повече от 3 недовършени кампании! Моля, посетете секция 'Кампании' във Вашия профил и попълнете необходимата информация за да завършите и подадете за одобрение някоя от тях!", "info")
                return
            } else {
                ProcessEvoApp
                .executeCommand('cmd-platformata-webshop-campaign-create', { legalTypeCode })
                .then((id)=>{
                    ProcessEvoApp.loadWorkspace('workspace-platformata-document-campaign', { id: id })
                })
                .catch((e)=>{
                    console.error(e)
                    ProcessEvoApp.showNotification(e.message, "error")
                })
                .finally(()=>{
                    ProcessEvoApp.hideLoader()
                })
            }

            }).catch(error => {
                console.error('Error fetching user profile:', error);
            });
        }

    }).catch(error => {
        console.error('Error fetching user profile:', error);
        ProcessEvoApp.showNotification("Unable to verify login status.", "error");
    });
}

//TODO: refactor - why do we need that?
$(document).ready(function(){
    $(".app-main-nav--mobile .open-bnt").click(function() {
        $(".app-main-nav--mobile-content").toggleClass("m-nav--show");
        $("html").toggleClass("prevent-scroll");

    });
    $(".app-main-nav--mobile .close-bnt").click(function() {
        $(".app-main-nav--mobile-content").toggleClass("m-nav--show");
        $("html").toggleClass("prevent-scroll");
    });

    $("#submenu-campaign").click(function() {
        $("#submenu-campaign-items").toggleClass("submenu-items--mobile--show");
        $("#submenu-campaign").toggleClass("ms-Icon--ChevronUp");
    });
    $("#submenu-about").click(function() {
        $("#submenu-about-items").toggleClass("submenu-items--mobile--show");
        $("#submenu-about").toggleClass("ms-Icon--ChevronUp");
    });
    
    $(".app-main-nav--mobile a").click(function() {
        $(".app-main-nav--mobile-content").toggleClass("m-nav--show");
        $("html").toggleClass("prevent-scroll");
    });
});
